import { ParamMap } from '@angular/router';

export class BaseType {
  Id?: any;
  Name?: string;
}

class Filters {
  Query?: string[];
  Make?: BaseType;
  Model?: BaseType;
  Type?: BaseType;

  Group1?: BaseType;
  Group2?: BaseType;
  Group3?: BaseType;
  Group4?: BaseType;
  Group5?: BaseType;
  Group6?: BaseType;

  Offset?: number;
  Limit?: number;
  Language?: string;

  private __default: any;
  private __lastSuccess: any;

  constructor() {
    this.Query = [];
    this.Make = {};
    this.Model = {};
    this.Type = {};

    this.Group1 = {};
    this.Group2 = {};
    this.Group3 = {};
    this.Group4 = {};
    this.Group5 = {};
    this.Group6 = {};

    this.Offset = 0;
    this.Limit = 10;
    this.Language = 'en';

    this.__default = {
      Query: [],
      Make: {},
      Model: {},
      Type: {},
      Group1: {},
      Group2: {},
      Group3: {},
      Group4: {},
      Group5: {},
      Group6: {},
      Offset: 0,
      Limit: 10,
      Language: 'en'
    };

    this.__lastSuccess = {
      Query: [],
      Make: {},
      Model: {},
      Type: {},
      Group1: {},
      Group2: {},
      Group3: {},
      Group4: {},
      Group5: {},
      Group6: {},
      Offset: 0,
      Limit: 10,
      Language: 'en'
    };
  }

  get(): any {
    return this;
  }

  getValue(key: string): any {
    return (this as any)[key];
  }

  getAggregationAndId(key: string): { id: any; lvl: number } {
    switch (key) {
      case 'group':
        if (this.Group6 && this.Group6.Id) { return { id: this.Group6.Id, lvl: 7 }; }
        if (this.Group5 && this.Group5.Id) { return { id: this.Group5.Id, lvl: 6 }; }
        if (this.Group4 && this.Group4.Id) { return { id: this.Group4.Id, lvl: 5 }; }
        if (this.Group3 && this.Group3.Id) { return { id: this.Group3.Id, lvl: 4 }; }
        if (this.Group2 && this.Group2.Id) { return { id: this.Group2.Id, lvl: 3 }; }
        if (this.Group1 && this.Group1.Id) { return { id: this.Group1.Id, lvl: 2 }; }
        return { id: 0, lvl: 1 };

      case 'app':
        if (this.Type && this.Type.Id) { return { id: this.Type.Id, lvl: 4 }; }
        if (this.Model && this.Model.Id) { return { id: this.Model.Id, lvl: 3 }; }
        if (this.Make && this.Make.Id) { return { id: this.Make.Id, lvl: 2 }; }
        return { id: 0, lvl: 1 };

      default:
        return { id: 0, lvl: 1 };
    }
  }

  setSuccessfulSearch(): void {
    this.__lastSuccess = {
      Query: this.Query,
      Make: this.Make,
      Model: this.Model,
      Type: this.Type,
      Group1: this.Group1,
      Group2: this.Group2,
      Group3: this.Group3,
      Group4: this.Group4,
      Group5: this.Group5,
      Group6: this.Group6,
      Offset: 0,
      Limit: 10,
      Language: this.Language
    };
  }

  getLastSuccessfulSearch(): any[] {
    const successful: any[] = [this.Language];

    this.setValue('Query', this.__lastSuccess.Query);
    const q = this.__lastSuccess.Query || [];
    successful.push(q.join(' ').replace('/', '%2F'));

    if (this.__lastSuccess.Type && this.__lastSuccess.Type.Id) {
      this.setValue('Type', this.__lastSuccess.Type);
      successful.push('4', this.__lastSuccess.Type.Id);
    } else if (this.__lastSuccess.Model && this.__lastSuccess.Model.Id) {
      this.setValue('Model', this.__lastSuccess.Model);
      successful.push('3', this.__lastSuccess.Model.Id);
    } else if (this.__lastSuccess.Make && this.__lastSuccess.Make.Id) {
      this.setValue('Make', this.__lastSuccess.Make);
      successful.push('2', this.__lastSuccess.Make.Id);
    } else {
      successful.push('1', '0');
    }

    if (this.__lastSuccess.Group6 && this.__lastSuccess.Group6.Id) {
      this.setValue('Group6', this.__lastSuccess.Group6);
      successful.push('7', this.__lastSuccess.Group6.Id);
    } else if (this.__lastSuccess.Group5 && this.__lastSuccess.Group5.Id) {
      this.setValue('Group5', this.__lastSuccess.Group5);
      successful.push('6', this.__lastSuccess.Group5.Id);
    } else if (this.__lastSuccess.Group4 && this.__lastSuccess.Group4.Id) {
      this.setValue('Group4', this.__lastSuccess.Group4);
      successful.push('5', this.__lastSuccess.Group4.Id);
    } else if (this.__lastSuccess.Group3 && this.__lastSuccess.Group3.Id) {
      this.setValue('Group3', this.__lastSuccess.Group3);
      successful.push('4', this.__lastSuccess.Group3.Id);
    } else if (this.__lastSuccess.Group2 && this.__lastSuccess.Group2.Id) {
      this.setValue('Group2', this.__lastSuccess.Group2);
      successful.push('3', this.__lastSuccess.Group2.Id);
    } else if (this.__lastSuccess.Group1 && this.__lastSuccess.Group1.Id) {
      this.setValue('Group1', this.__lastSuccess.Group1);
      successful.push('2', this.__lastSuccess.Group1.Id);
    } else {
      successful.push('1', '0');
    }

    return successful;
  }

  setValue(key: string, value: any): any {
    if (this.hasOwnProperty(key)) {
      (this as any)[key] = value;
      return this;
    }
  }

  resetFilters(resetLanguage: boolean): any {
    this.Query = [];
    this.Make = {};
    this.Model = {};
    this.Type = {};

    this.Group1 = {};
    this.Group2 = {};
    this.Group3 = {};
    this.Group4 = {};
    this.Group5 = {};
    this.Group6 = {};

    this.Offset = 0;
    this.Limit = 10;

    if (resetLanguage) {
      this.Language = 'en';
    }
  }

  resetValue(key: string): any {
    if (this.__default && this.__default.hasOwnProperty(key)) {
      (this as any)[key] = this.__default[key];
      return this;
    }
  }

  private getNthParent(node: any, n: number) {
    let cur = node;
    for (let i = 0; i < n && cur; i++) {
      cur = cur.Parent;
    }
    return cur;
  }

  private setFilterFromItemAtDepth(state: any, key: string, aggregationType: string, parentDepth: number = 0): void {
    const aggs = state && state.result && state.result.Aggregations;
    const agg = aggregationType === 'applications'
      ? (aggs ? aggs.ApplicationsAggregationItem : null)
      : (aggs ? aggs.ArticleGroupAggregationItem : null);

    const base = agg && agg.BaseItems && agg.BaseItems[0] ? agg.BaseItems[0] : null;
    const node = parentDepth === 0 ? base : this.getNthParent(base, parentDepth);

    if (node && node.Id != null) {
      (this as any)[key] = { Id: node.Id, Name: node.Name };
    }
  }

  setFilterFromItemProper(state: any, key: string, aggregationType: string): void {
    this.setFilterFromItemAtDepth(state, key, aggregationType, 0);
  }
  setFilterFromItemParent(state: any, key: string, aggregationType: string): void {
    this.setFilterFromItemAtDepth(state, key, aggregationType, 1);
  }
  setFilterFromItemGrandParent(state: any, key: string, aggregationType: string): void {
    this.setFilterFromItemAtDepth(state, key, aggregationType, 2);
  }

  setValuesBasedOnParamMap(paramMap: ParamMap): void {
    if (paramMap.has('lang')) {
      this.setValue('Language', paramMap.get('lang'));
    }
    if (paramMap.has('query')) {
      const q = paramMap.get('query');
      this.setValue('Query', this.removeWhitespace(q ? q.split(' ') : []));
    }

    if (paramMap.has('app') && paramMap.get('app') === '4') {
      this.resetValue('Offset');
      this.setValue('Type', { Id: paramMap.get('appId') });
    }
    if (paramMap.has('app') && paramMap.get('app') === '3') {
      this.resetValue('Offset');
      this.resetValue('Type');
      this.setValue('Model', { Id: paramMap.get('appId') });
    }
    if (paramMap.has('app') && paramMap.get('app') === '2') {
      this.resetValue('Offset');
      this.resetValue('Type');
      this.resetValue('Model');
      this.setValue('Make', { Id: paramMap.get('appId') });
    }

    if (paramMap.has('group')) {
      const lvl = paramMap.get('group');
      const id = paramMap.get('groupId');

      this.resetValue('Offset');

      switch (lvl) {
        case '7': 
          this.resetValue('Group6');
          this.setValue('Group6', { Id: id });
          break;
        case '6':
          this.resetValue('Group6');
          this.resetValue('Group5');
          this.setValue('Group5', { Id: id });
          break;
        case '5':
          this.resetValue('Group6');
          this.resetValue('Group5');
          this.resetValue('Group4');
          this.setValue('Group4', { Id: id });
          break;
        case '4':
          this.resetValue('Group6');
          this.resetValue('Group5');
          this.resetValue('Group4');
          this.resetValue('Group3');
          this.setValue('Group3', { Id: id });
          break;
        case '3':
          this.resetValue('Group6');
          this.resetValue('Group5');
          this.resetValue('Group4');
          this.resetValue('Group3');
          this.resetValue('Group2');
          this.setValue('Group2', { Id: id });
          break;
        case '2':
          this.resetValue('Group6');
          this.resetValue('Group5');
          this.resetValue('Group4');
          this.resetValue('Group3');
          this.resetValue('Group2');
          this.resetValue('Group1');
          this.setValue('Group1', { Id: id });
          break;
        default:
          this.resetValue('Group6');
          this.resetValue('Group5');
          this.resetValue('Group4');
          this.resetValue('Group3');
          this.resetValue('Group2');
          this.resetValue('Group1');
          break;
      }
    }
  }

  removeWhitespace(value) {
    if (typeof(value) === 'string') {
      value = value.split(' ');
    }
    for (let i = 0; i < value.length; ++i) {
      if (value[i] === '') {
        value.splice(i, 1);
        --i;
      }
    }
    return value;
  }
}

export let Filter = new Filters();
